import { render, staticRenderFns } from "./orderCom.vue?vue&type=template&id=79a3e14f&scoped=true"
import script from "./orderCom.vue?vue&type=script&lang=js"
export * from "./orderCom.vue?vue&type=script&lang=js"
import style0 from "./orderCom.vue?vue&type=style&index=0&id=79a3e14f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a3e14f",
  null
  
)

export default component.exports